import gql from 'graphql-tag';

export default gql`
query {
  getUserMenu {
    __typename
    id
    items {
      __typename
      label
      icon
      path
      ordinal
      items {
        __typename
        label
        path
        ordinal
      }
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/_Shared/GetUserMenuQuery.js